import styled from '@emotion/styled';
import { Color } from '../../../styles/Color';
import { Css } from '../../../ui';

export const ContentHeaderContentWrap = styled.div`
	display: flex;
	flex-direction: column;
	height: auto;
	background: ${Color.Neutral2};
	margin-bottom: ${Css.pxToRem(40)};
`;

export const LandingHeaderContentWrap = styled(ContentHeaderContentWrap)`
	padding-bottom: ${Css.pxToRem(115)};
`;
